import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    flex-grow: 1;\n\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { colorGrey50 } from '../../../tokens';
import { getPropsBlocker } from '../../../utils';

var headerStyle = function headerStyle(_ref) {
  var theme = _ref.theme;

  var _a;

  var SideSheet = (_a = theme === null || theme === void 0 ? void 0 : theme.componentOverrides) === null || _a === void 0 ? void 0 : _a.SideSheet;
  return SideSheet ? SideSheet.Header.base : {};
};

export var SideSheetHeader = styled.div.withConfig(getPropsBlocker())(_templateObject(), headerStyle);
export var titleTypographyStyle = {
  marginTop: 0,
  marginBottom: '8px'
};
export var descriptionTypographyStyle = {
  color: colorGrey50,
  marginBottom: 0,
  marginTop: 0
};